import { Route, Routes } from "react-router-dom";
import AddVendorQuotationExcelMailScreen from "screens/App/CRM/VendorLead/vendorLeadComponents/AddVendorQuotationExcelMailScreen";
import AddVendorQuotationPdfMailScreen from "screens/App/CRM/VendorLead/vendorLeadComponents/AddVendorQuotationPdfMailScreen";
import AssignLeadScreen from "screens/App/CRM/VendorLead/vendorLeadComponents/AssignLeadScreen";
import VendorLeadReviewScreen from "screens/App/CRM/VendorLead/vendorLeadComponents/VendorLeadReviewScreen";
import { VendorLeadCreateScreen } from "screens/App/CRM/VendorLead/VendorLeadCreateScreen";
import VendorLeadDetailScreen from "screens/App/CRM/VendorLead/VendorLeadDetailScreen";
import { VendorLeadEditScreen } from "screens/App/CRM/VendorLead/VendorLeadEditScreen";
import VendorLeadImportSummaryScreen from "screens/App/CRM/VendorLead/Vendorleadimportsummaryscreen";
import { VendorLeadListScreen } from "screens/App/CRM/VendorLead/VendorLeadListScreen";
import VendorLeadQuotationPdfExcelListScreen from "screens/App/CRM/VendorLead/VendorLeadQuotationPdfExcelListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorLeadRouter = () => {
  return (
    <Routes>
      <Route path="/list" element={<VendorLeadListScreen />} />
      <Route
        path="/quotation-list-vendor"
        element={<VendorLeadQuotationPdfExcelListScreen />}
      />
      <Route path="/add-pdf" element={<AddVendorQuotationPdfMailScreen />} />
      <Route
        path="/add-excel"
        element={<AddVendorQuotationExcelMailScreen />}
      />
      <Route path="/create" element={<VendorLeadCreateScreen />} />
      <Route path="/:id/detail" element={<VendorLeadDetailScreen />} />
      <Route path=":id/edit" element={<VendorLeadEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
      <Route path="/bulk-review" element={<VendorLeadReviewScreen />} />
      <Route path="/assign" element={<AssignLeadScreen />} />
      <Route
        path="/import-summary"
        element={<VendorLeadImportSummaryScreen />}
      />
    </Routes>
  );
};

export default VendorLeadRouter;
